import { BaseResponseSchema } from '../../schemas.js';
import { jobImportPreviewRequestSchema, jobImportPreviewResponseSchema, jobsActiveCheckResponseSchema, tenantJobAbortBodySchema, tenantJobAbortQuerySchema, tenantJobDetailQuerySchema, tenantJobDetailResponseSchema, tenantJobProgressQuerySchema, tenantJobProgressResponseSchema, tenantJobsActiveCheckClientQuerySchema, tenantJobsActiveListQuerySchema, tenantJobsActiveListResponseSchema, tenantJobsCreatableTypesResponseSchema, tenantJobsListQuerySchema, tenantJobsListResponseSchema, } from '../../job-workflow.schemas.js';
import { tenantJobIdParamSchema } from '../../tenant-job-id.schemas.js';
/** REST contract for `insight-api/src/routes/tenant/jobs.routes.ts`. */
export const jobsContract = {
    list: {
        method: 'GET',
        path: '/tenant/jobs',
        query: tenantJobsListQuerySchema,
        response: tenantJobsListResponseSchema,
        responseStyle: 'parse-response',
        queryLimitMax: 100,
        errorMessage: 'Failed to list jobs',
    },
    getCreatableTypes: {
        method: 'GET',
        path: '/tenant/jobs/creatable-types',
        response: tenantJobsCreatableTypesResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'creatableTypes',
        errorMessage: 'Failed to get creatable job types',
    },
    activeCheck: {
        method: 'GET',
        path: '/tenant/jobs/active-check',
        query: tenantJobsActiveCheckClientQuerySchema,
        response: jobsActiveCheckResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to check active jobs',
    },
    importPreview: {
        method: 'POST',
        path: '/tenant/jobs/import-preview',
        body: jobImportPreviewRequestSchema,
        response: jobImportPreviewResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to preview job import',
    },
    listActive: {
        method: 'GET',
        path: '/tenant/jobs/active',
        query: tenantJobsActiveListQuerySchema,
        response: tenantJobsActiveListResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to list active jobs',
    },
    getProgress: {
        method: 'GET',
        path: '/tenant/jobs/:jobId/progress',
        pathParams: tenantJobIdParamSchema,
        query: tenantJobProgressQuerySchema,
        response: tenantJobProgressResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get unified job progress',
    },
    getDetail: {
        method: 'GET',
        path: '/tenant/jobs/:jobId',
        pathParams: tenantJobIdParamSchema,
        query: tenantJobDetailQuerySchema,
        response: tenantJobDetailResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get job detail',
    },
    delete: {
        method: 'DELETE',
        path: '/tenant/jobs/:jobId',
        pathParams: tenantJobIdParamSchema,
        query: tenantJobAbortQuerySchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to delete job',
    },
    abort: {
        method: 'POST',
        path: '/tenant/jobs/:jobId/abort',
        pathParams: tenantJobIdParamSchema,
        query: tenantJobAbortQuerySchema,
        body: tenantJobAbortBodySchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to abort job',
    },
};
//# sourceMappingURL=jobs.contract.js.map